import type { ApiNodeDataIdentityDocument, IdDocKind } from '@onefootprint/request-types/dashboard';
import type { TFunction } from 'i18next';
import { ID_DOC_KINDS_IN_DISPLAY_ORDER } from '../../../identity-document/id-doc-kinds';

// "Passport or ID card", "Passport, ID card, or Driver's license". The dashboard only ships English copy.
const listFormat = new Intl.ListFormat('en', { type: 'disjunction' });

export const getIdentityDocumentSubtitle = (
  data: ApiNodeDataIdentityDocument,
  t: TFunction<'playbook-builder'>,
  getDocLabel: (doc: IdDocKind) => string,
): string => {
  const { global, countrySpecific } = data.documentTypesAndCountries;
  const perCountry = Object.values(countrySpecific) as IdDocKind[][];
  const collected = new Set([global, ...perCountry].flat());
  const kinds = ID_DOC_KINDS_IN_DISPLAY_ORDER.filter(kind => collected.has(kind));

  return kinds.length ? listFormat.format(kinds.map(getDocLabel)) : t($ => $.collectDocument.identityDocument);
};
